const SUPPRESS_KEY = "tf:suppress-route-focus";

export function suppressRouteFocusReset() {
  try {
    sessionStorage.setItem(SUPPRESS_KEY, "1");
  } catch {}
}

export function isRouteFocusSuppressed(): boolean {
  try {
    return sessionStorage.getItem(SUPPRESS_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearRouteFocusSuppressed() {
  try {
    sessionStorage.removeItem(SUPPRESS_KEY);
  } catch {}
}
